import { render, staticRenderFns } from "./RowTable.vue?vue&type=template&id=ba99bff6&scoped=true&"
import script from "./RowTable.vue?vue&type=script&lang=js&"
export * from "./RowTable.vue?vue&type=script&lang=js&"
import style0 from "./RowTable.vue?vue&type=style&index=0&id=ba99bff6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba99bff6",
  null
  
)

export default component.exports